import yup from 'src/libraries/validator.library';

const SensitiveCommunitiesShape = {
  sensitiveCommunity: yup.string().required(),
  sensitiveCommunityPamLead: yup.string().nullable(),
};

export const SensitiveCommunitiesSchema = yup
  .object()
  .shape({
    sensitiveCommunityId: yup.number(),
    ...SensitiveCommunitiesShape,
  })
  .defined();

export const SensitiveCommunitiesListSchema = yup
  .object({
    sensitiveCommunities: yup
      .object({
        count: yup.number(),
        rows: yup
          .array()
          .of(
            yup
              .object()
              .shape({
                sensitiveCommunityId: yup.number(),
                ...SensitiveCommunitiesShape,
              })
              .defined()
          )
          .defined(),
      })
      .defined(),
  })
  .defined();

export const SensitiveCommunitiesFormSchema = yup
  .object()
  .shape({
    ...SensitiveCommunitiesShape,
  })
  .defined();

export type ISensitiveCommunities = yup.InferType<typeof SensitiveCommunitiesSchema>;
export type ISensitiveCommunitiesRow = yup.InferType<typeof SensitiveCommunitiesListSchema>;
export type ISensitiveCommunitiesForm = yup.InferType<typeof SensitiveCommunitiesFormSchema>;
